import { IModel } from 'makerjs';
import isUndefined from "lodash/isUndefined";

import Length from "../../../source/js/shared/models/Geometry/Length";
import ShapeDrillHoleGeneratorFactory from "./ShapeDrillHoleGeneratorFactory";
import DrillHole from "./DrillHole";
import Invalid from './DrillHoleGenerators/Invalid';

export default class PresetDrillHoles {
	private readonly shape: string;
	private readonly parentModel: MakerJs.IModel;
	private readonly primitives: Record<string, number>;
	private readonly diameter: Length;
	private readonly topBottom: Length;
	private readonly leftRight: Length;
	private readonly startingPoint: Length;

	private maxDistance: Length;

	constructor( shape: string, parentModel: IModel, primitives: Record<string, number>, diameter: Length, maxDistance: Length, topBottom: Length, leftRight: Length, startingPoint: Length ) {
		this.shape = shape;
		this.diameter = diameter;
		this.primitives = primitives;
		this.maxDistance = maxDistance;
		this.topBottom = topBottom;
		this.leftRight = leftRight;
		this.startingPoint = startingPoint;
		this.parentModel = parentModel;
	}

	getId(): string {
		return `preset-drillHoles`;
	}

	getPath(): DrillHole[] {
		let drillHoles = [];

		// Check shape
		if ( this.shape === 'rectangle' ) {
			drillHoles = this.generatePresetHoles();
		}

		return drillHoles;
	}

	getAsModel(): IModel {
		const drillHoles = this.getPath();
		const drillHolesModel = { paths: {}, type: 'preset-drillHole' };

		drillHoles.forEach( ( drillHole ) => {
			drillHolesModel.paths = Object.assign( drillHolesModel.paths, drillHole.getAsModel().paths );
		} );

		return drillHolesModel;
	}

	generatePresetHoles(): DrillHole[] {
		const shapeDrillHoleGenerator = new ShapeDrillHoleGeneratorFactory().getShapeDrillHoleGenerator( this.shape, this.parentModel );

		if ( shapeDrillHoleGenerator instanceof Invalid ) { return []; }

		// Map each dimension
		const entries = this.calculateForLengthAndWidth();

		return shapeDrillHoleGenerator.fromEdge( [ entries.length, entries.width, entries.length, entries.width ], this.topBottom, this.leftRight, this.diameter, this.startingPoint );
	}

	calculateForLengthAndWidth(): Record<string, number> {
		return {
			length: this.calculateDrillHolesForEdge( Length.from_cm( this.primitives.length ) ),
			width: this.calculateDrillHolesForEdge( Length.from_cm( this.primitives.width ) ),
		};
	}

	calculateDrillHolesForEdge( value: Length ): number {
		if ( isUndefined( value ) || value.in_mm() === 0 || this.maxDistance.in_cm() === 0 ) {
			return 0;
		}

		const length = value.subtract( this.startingPoint.multiply( 2 ) );
		const distanceBetweenHoles = Math.ceil( length.divide( this.maxDistance.in_cm() ).in_cm() );
		const realDistance = length.divide( distanceBetweenHoles );

		return Math.ceil( value.divide( realDistance.in_cm() ).in_cm() );
	}

	getOffsetLines(): [] {
		return [];
	}
}
